import React, { useState, useEffect } from 'react';
import useNetwork from '../useNetwork';

export function VerifyEmail (props) {
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);

    const [isValid, setIsValid] = useState(null);

    useEffect(() => {
        const verifyEmail = async () => {
            const url = 'api/site/verifyemail/' + props.match.params.verifyCode + '/' + props.match.params.secureBidderUserId;

            const response = await netRequest(url);

            setIsValid(response.data.result);
        };

        verifyEmail();

    }, []);


    if (isValid == false) {
        return <div>That verification code does not exist.  Please check your email again.  If you copied the url into your browser, make sure the whole link is there</div>
    }

    if (isValid == true) {
        return <div>Your email has been validated.</div>
    }

    return <div>Validating your email address</div>
}
